// extracted by mini-css-extract-plugin
export default {"tariff":"Tariff_tariff__2wJrj","header":"Tariff_header__bZQOP","tariffName":"Tariff_tariffName__+OgxA","body":"Tariff_body__xU63P","inputLabel":"Tariff_inputLabel__iW5Di"};